import { render, staticRenderFns } from "./auditComicRecordCol.vue?vue&type=template&id=2aad3192"
import script from "./auditComicRecordCol.vue?vue&type=script&lang=js"
export * from "./auditComicRecordCol.vue?vue&type=script&lang=js"
import style0 from "./auditComicRecordCol.vue?vue&type=style&index=0&id=2aad3192&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports